import Icon from 'app/components/partials/icon';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { useIdPolyfill } from '../../hooks/use-id-polyfill';
import React, { useRef, useState } from 'react';

const Review = ({ data }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);
    const dotsRef = useRef(null);

    // TODO: replace with React.useId() when upgraded to react 18+
    const blockId = useIdPolyfill();

    const getSlideId = (idx) => `${blockId}-slide-${idx}`;

    const renderReviewItem = (item, index) => (
        <div id={getSlideId(index)} className="item" key={index}
            role="tabpanel"
            aria-roledescription="slide"
            aria-label={`${index + 1} of ${data.length}`}
        >
            <div className="inner">
                <div className="stars">
                    {Array.from({ length: Number(item.stars) }, (_, k) => (
                        <Icon name="star-rating" key={k}/>
                    ))}
                </div>
                <blockquote>{item.quote}</blockquote>
                {item.source && !item.source_url && <p>{item.source}</p>}
                {item.source && item.source_url && <a href={item.source_url}>{item.source}</a>}
                {item.stars > 0 &&
                    <p className="sr-only">{item.stars} stars</p>
                }
            </div>
        </div>
    );

    const renderDots = (dots) => (
        <ul
            style={{ display: 'flex' }}
            role="tablist"
            aria-label="Slides controls"
            ref={dotsRef}
            onKeyDown={(e) => {
                switch (e.key) {
                    case 'ArrowRight':
                        sliderRef.current.slickNext();
                        break;
                    case 'ArrowLeft':
                        sliderRef.current.slickPrev();
                        break;
                    default:
                }
            }}
        >
            {dots}
        </ul>
    );

    const renderPaging = (i) => (
        <button
            className="dot"
            tabIndex={currentSlide === i ? undefined : '-1'}
            aria-selected={currentSlide === i}
            type="button"
            role="tab"
            aria-label={`Slide ${i + 1}`}
            aria-controls={getSlideId(i)}
        ></button>
    );

    const settings = {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: (dots) => renderDots(dots),
        customPaging: renderPaging,
        beforeChange: (oldIdx, newIdx) => {
            // force focus on the selected tab (in case of using keyboard)
            dotsRef.current.children.item(newIdx).getElementsByClassName('dot')[0].focus();
        },
        afterChange: (i) => {
            setCurrentSlide(i);
        }
    };

    return (
        <section className="content-block || review-carousel || constrain-width large"
            aria-roledescription="carousel"
            aria-label="Reviews of this show"
        >
            <Slider
                ref={sliderRef}
                {...settings}
            >
                {data.map((item, index) => renderReviewItem(item, index))}
            </Slider>
        </section>
    );
};

Review.propTypes = {
    data: PropTypes.array.isRequired
};

export default Review;
